export default __webpack_public_path__ + "b9fedf3cdd365570cbc40fa5a7c87d69.svg";